export function SectionHeader({
  icon,
  title,
  kicker,
}: {
  icon: string;
  title: string;
  kicker?: string;
}) {
  return (
    <div className="mb-3 flex items-center gap-3">
      <span className="text-2xl">{icon}</span>
      <h2 className="display text-2xl text-ink">{title}</h2>
      <span className="h-px flex-1 bg-gold/40" />
      {kicker && (
        <span className="text-[11px] font-semibold uppercase tracking-widest text-black/40">
          {kicker}
        </span>
      )}
    </div>
  );
}
